import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Reviews = () => {
  const reviews = [
    {
      name: 'Michael Thompson',
      date: '2 weeks ago',
      rating: 5,
      text: 'Excellent service! My Honda Accord needed major body work after an accident. The team at Premium Auto handled everything with my insurance company and the repairs were flawless. Highly recommend!',
      verified: true
    },
    {
      name: 'Sarah Chen',
      date: '1 month ago',
      rating: 5,
      text: 'Best auto shop in North York! They serviced my BMW and the work was impeccable. Professional, honest, and their prices are very reasonable. Will definitely be coming back for all my car needs.',
      verified: true
    },
    {
      name: 'David Martinez',
      date: '3 weeks ago',
      rating: 5,
      text: 'I bring all my company vans here for fleet maintenance. Always reliable, fast turnaround, and they work with my schedule. The pick-up and drop-off service is a huge time saver for my business.',
      verified: true
    },
    {
      name: 'Jennifer Wilson',
      date: '1 week ago',
      rating: 5,
      text: 'Outstanding collision repair work on my Mercedes. They matched the paint perfectly and you can\'t even tell there was damage. The staff was friendly and kept me updated throughout the process.',
      verified: true
    },
    {
      name: 'Robert Kumar',
      date: '2 months ago',
      rating: 5,
      text: 'Been coming here since 2015 and never disappointed. They work on everything from my family Toyota to my Audi. Trustworthy mechanics who actually care about quality work. Five stars all the way!',
      verified: true
    }
  ];

  return (
    <section className="py-20 bg-[#0f0f0f]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <Star className="w-6 h-6 text-[#ff6b35] fill-[#ff6b35]" />
            <Star className="w-6 h-6 text-[#ff6b35] fill-[#ff6b35]" />
            <Star className="w-6 h-6 text-[#ff6b35] fill-[#ff6b35]" />
            <Star className="w-6 h-6 text-[#ff6b35] fill-[#ff6b35]" />
            <Star className="w-6 h-6 text-[#ff6b35] fill-[#ff6b35]" />
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            What Our Customers Say
          </h2>
          <div className="h-1 w-24 bg-[#ff6b35] mx-auto rounded-full"></div>
          <p className="text-gray-400 text-lg mt-6">
            Real reviews from real customers on Google
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {reviews.map((review, index) => (
            <Card
              key={index}
              className="bg-gradient-to-br from-[#1a1a1a] to-[#151515] border border-white/10 hover:border-[#ff6b35]/30 transition-all duration-300 group"
            >
              <CardContent className="p-6">
                {/* Quote Icon */}
                <Quote className="w-8 h-8 text-[#ff6b35]/30 mb-4" />

                {/* Rating */}
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-4 h-4 text-[#ff6b35] fill-[#ff6b35]"
                    />
                  ))}
                </div>

                {/* Review Text */}
                <p className="text-gray-300 mb-6 leading-relaxed text-sm">
                  "{review.text}"
                </p>

                {/* Reviewer Info */}
                <div className="flex items-center justify-between pt-4 border-t border-white/5">
                  <div>
                    <h4 className="text-white font-semibold text-sm">
                      {review.name}
                    </h4>
                    <p className="text-gray-500 text-xs mt-1">{review.date}</p>
                  </div>
                  {review.verified && (
                    <div className="flex items-center gap-1 text-xs text-gray-500">
                      <div className="w-4 h-4 rounded-full bg-[#ff6b35]/20 flex items-center justify-center">
                        <svg className="w-2.5 h-2.5 text-[#ff6b35]" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <span>Verified</span>
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Google Link */}
        <div className="text-center">
          <a
            href="https://www.google.com/search?q=Premium+Auto+Repairs+%26+Sales+21+Millwick+Dr+North+York"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-[#ff6b35] text-white font-semibold px-8 py-4 rounded-lg transition-all duration-200"
          >
            <img 
              src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'%3E%3Cpath fill='%234285F4' d='M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z'/%3E%3Cpath fill='%2334A853' d='M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z'/%3E%3Cpath fill='%23FBBC05' d='M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z'/%3E%3Cpath fill='%23EA4335' d='M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z'/%3E%3C/svg%3E"
              alt="Google"
              className="w-5 h-5"
            />
            Read More Reviews on Google
          </a>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
